import clsx from 'clsx';

const TextInput = ({
  value,
  onChange,
  placeholder = '',
  maxLength,
  disabled = false,
  isValid = true,
  type = 'text',
  className = '',
  ...props
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      maxLength={maxLength}
      disabled={disabled}
      value={value}
      className={clsx(
        className,
        {
          'disabled': disabled,
          '!shadow-[0_0_0_0px_#00ff00]': isValid,
          '!shadow-[0_0_0_2px_#FF2E6C]': !isValid,
        }
      )}
      onChange={(e) => onChange(e.target.value)}
      {...props}
    />
  );
};

export default TextInput;
